export default __webpack_public_path__ + "static/media/14.fe7a0f68.png";